import {
  Box,
  Button,
  Chip,
  Grid,
  Grow,
  makeStyles,
  Toolbar,
  Tooltip,
  Typography,
} from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';

import { FilterPropertyType, IFiltersOptions } from 'types';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
  },
  gridWrapper: {
    flexGrow: 1,
  },
  chipItem: {
    maxWidth: 'calc(100vw - 31.5%)',
  },
});

interface Props {
  filters: IFiltersOptions[];
  onRemove?: (filterProperty: FilterPropertyType) => void;
  onRemoveAll?: () => void;
}

function AppliedFilters(props: Props) {
  const { filters, onRemove, onRemoveAll } = props;
  const classes = useStyles();

  const handleRemove = (filterProperty: FilterPropertyType) => {
    onRemove?.(filterProperty);
  };

  return (
    <Toolbar style={{ minHeight: 36 }} disableGutters>
      <Grow in={filters.length > 0} timeout={500} unmountOnExit mountOnEnter>
        <Box className={classes.root}>
          <Grid
            container
            alignItems="center"
            spacing={2}
            className={classes.gridWrapper}
          >
            {filters?.map(filter => (
              <Grid
                key={filter.labelProperty}
                item
                className={classes.chipItem}
              >
                <Chip
                  size="small"
                  label={
                    <Typography variant="body2" noWrap>
                      <Box component="b">{filter.labelProperty}: </Box>
                      {filter.labelValue}
                    </Typography>
                  }
                  onDelete={
                    onRemove ? () => handleRemove(filter.property) : undefined
                  }
                  deleteIcon={
                    <Tooltip arrow placement="top" title="Remover">
                      <CancelIcon />
                    </Tooltip>
                  }
                />
              </Grid>
            ))}

            {onRemoveAll && (
              <Grid item>
                <Button size="small" variant="outlined" onClick={onRemoveAll}>
                  Limpar
                </Button>
              </Grid>
            )}
          </Grid>
        </Box>
      </Grow>
    </Toolbar>
  );
}

export default AppliedFilters;
